export default {
  th: {
    contestAward: {
      winner_award: "ผู้เล่นที่โดดเด่น",
      description:
        "เราได้ผู้ชนะแล้ว! ซื้อขายและคว้ารางวัลใหญ่ ขอแสดงความยินดี!",
      lucky_draw: "จับฉลากชิงโชค",
      title_not_found: "ไม่มีรางวัลจากการจับสลาก",
      description_not_found: "รางวัลจากการจับสลากยังไม่สามารถรับได้ในขณะนี้",
      next: "ถัดไป",
    },
  },
  lo: {},
  en: {
    contestAward: {
      winner_award: "Top Performers",
      description: "Congratulations!\nThe grand prize has been awarded.",
      lucky_draw: "Lucky Draw",
      title_not_found: "No Prize Available",
      description_not_found:
        "The lucky draw prize cannot be claimed at this moment.",
      next: "Next",
    },
  },
  hi: {},
  ms: {
    contestAward: {
      winner_award: "Pelaku terbaik",
      description:
        "Kami ada pemenang! Berdagang dan menangi hadiah utama, tahniah!",
      lucky_draw: "Cabutan Bertuah",
      title_not_found: "Tiada hadiah cabutan bertuah",
      description_not_found:
        "hadiah cabutan bertuah tidak diambil pada masa ini",
      next: "Seterusnya",
    },
  },
  id: {
    contestAward: {
      winner_award: "Pemain terbaik",
      description:
        "Kami telah mendapatkan pemenangnya! Berdagang dan menangkan hadiah utama, selamat!",
      lucky_draw: "Undian Berhadiah",
      title_not_found: "Tidak ada hadiah undian",
      description_not_found: "hadiah undian tidak diambil saat ini",
      next: "Selanjutnya",
    },
  },
  zh: {
    contestAward: {
      winner_award: "最佳表现者",
      description: "我们有一位优胜 者！交易并赢得大奖, 恭喜！",
      lucky_draw: "幸运抽奖",
      title_not_found: "没有幸运抽奖奖品",
      description_not_found: "幸运抽奖奖品目前 无法领取",
      next: "下一条",
    },
  },
  vi: {
    contestAward: {
      winner_award: "Người biểu diễn xuất sắc",
      description:
        "Chúng tôi có người chiến thắng! Giao dịch và giành được giải thưởng chính, xin chúc mừng!",
      lucky_draw: "Rút thăm may mắn",
      title_not_found: "Không có giải thưởng rút thăm may mắn",
      description_not_found:
        "giải thưởng rút thăm may mắn hiện không được nhận",
      next: "Tiếp theo",
    },
  },
  ko: {},
  fil: {},
  ja: {
    contestAward: {
      winner_award: "成績優秀者",
      description:
        "優勝者が決定しま した！ トレードしてメイ ン賞品を獲得しま した。おめでとう ございます！",
      lucky_draw: "抽選",
      title_not_found: "抽選賞品はありま せん",
      description_not_found: "抽選賞品は現在受 け取れません",
      next: "次へ",
    },
  },
  es: {
    contestAward: {
      winner_award: "Mejores desempeñadores",
      description:
        "¡Tenemos un ganador! ¡Intercambia y gana el premio principal, enhorabuena!",
      lucky_draw: "Sorteo de la suerte",
      title_not_found: "No hay premio del sorteo",
      description_not_found:
        "El premio del sorteo no se recoge en este momento",
      next: "Siguiente",
    },
  },
  pt: {
    contestAward: {
      winner_award: "Melhores Desempenhos",
      description: "Parabéns!\nO prêmio principal foi concedido.",
      lucky_draw: "Sorteio",
      title_not_found: "Nenhum Prêmio Disponível",
      description_not_found:
        "O prêmio do sorteio não pode ser reivindicado neste momento.",
      next: "Próximo",
    },
  },
};
